export default __webpack_public_path__ + "fe9c1fd70833604161903b3b1a9a0394.png";